'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$View$() {
}
export { $c_Lpresto_crud$View$ as $c_Lpresto_crud$View$ };
$p = $c_Lpresto_crud$View$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$View$;
/** @constructor */
function $h_Lpresto_crud$View$() {
}
export { $h_Lpresto_crud$View$ as $h_Lpresto_crud$View$ };
$h_Lpresto_crud$View$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 2666181;
});
$p.l = (function() {
  return "View";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "View";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_crud$View$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$View$, "presto.crud$View$", ({
  VP: 1,
  cy: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_crud$View$ as $d_Lpresto_crud$View$ };
var $n_Lpresto_crud$View$;
function $m_Lpresto_crud$View$() {
  if ((!$n_Lpresto_crud$View$)) {
    $n_Lpresto_crud$View$ = new $c_Lpresto_crud$View$();
  }
  return $n_Lpresto_crud$View$;
}
export { $m_Lpresto_crud$View$ as $m_Lpresto_crud$View$ };
//# sourceMappingURL=presto.crud$-View$.js.map
